import { settings } from 'accounting-js'

// Format currency settings to Indonesian Rupiah format
settings.decimal = ','
settings.thousand = '.'
